import { Chart } from "primereact/chart";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";
import { memo, useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { SelectButton } from "primereact/selectbutton";
import { MultiSelect } from "primereact/multiselect";
import { ColumnGroup } from "primereact/columngroup";
import QuebrasDiaArtigo from "./QuebrasDiaArtigo";
import QuebrasResumoArtigo from "./QuebrasResumoDiaArtigo";
import QuebrasOcorrenciasArtigo from "./QuebrasOcorrenciaArtigo"
import QuebrasControle from "./GraficoControleQuebras"
import { Row } from "primereact/row";
import React from "react";
import { useReactToPrint } from "react-to-print";
import { useReport } from "../../context/report";

export default memo(function Quebras() {
    const [filtered, setFiltered] = useState([]);
    const [showTotal, setShowTotal] = useState(true);
    const [trama, setTrama] = useState(0);
    const [urdume, setUrdume] = useState(0);

    const [turmaDia, setTurmaDia] = useState('A');
    const [selectedTeares, setSelectedTeares] = useState(null);
    const [tearesOptions, setTearesOptions] = useState([]);
    const [uniqueDates, setUniqueDates] = useState([]);
    const [processedDiaData, setProcessedDiaData] = useState([]);
    const turmaOptions = ['A', 'B', 'C', 'D']; 

    const { handlePrint, data, printing } = useReport();

    const tableDiaRef = useRef(null);
    const [printingDia, setPrintingDia] = useState(false);

    const handlePrintDia = useReactToPrint({
        content: () => tableDiaRef.current,
        onBeforeGetContent: () => {
            return new Promise((resolve) => {
                setPrintingDia(true);
                setTimeout(() => {
                    resolve();
                }, 500);
            });
        },
        onAfterPrint: () => {
            setPrintingDia(false);
        }
    });

    const options = {
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                align: 'end',
                anchor: 'end',
                formatter: (value, context) => {
                    return Intl.NumberFormat('pt-BR').format(value)
                },
                font: {
                    size: printing ? 20 : 24
                },
                color: "#2c3e50"
            },
            title: {
                display: true,
                text: 'Gráfico de Quebras - ' + data.periodo,
                font: {
                    size: 18
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    font: {
                        size: 16
                    },
                    color: "#000"
                }
            },
        }
    }

    const returnLabels = () => {
        let labels = [];
        data.chart.forEach(element => {
            labels.push([
                `Turma: ${element.turma}`,
                `Quebras ${Intl.NumberFormat('pt-BR').format(element.total)}`,
                `Média: ${Intl.NumberFormat('pt-BR').format(element.media)}`,
                `Dias: ${element.dias}`
            ]);
        });
        return labels;
    }

    const QuebrasTurma = () => {
        let values = [];
        let colors = [];
        let medians = [];

        data.chart.forEach(element => {
            values.push(element.total);
            medians.push(element.media);
            colors.push(element.color);
        });

        const chartData = {
            labels: returnLabels(),
            datasets: [
                {
                    label: 'Total',
                    data: values,
                    backgroundColor: colors
                },
                {
                    label: 'Média',
                    data: medians,
                    backgroundColor: '#2ecc71',
                }
            ]
        }

        return (
            <Chart
                id="chartQuebras1"
                data={chartData}
                height={printing ? "210mm" : "650px"}
                width={printing ? "297mm" : "100%"}
                options={options}
                plugins={[ChartDataLabels]}
                type="bar"
            />
        )
    };

    const QuebrasTotais = () => {
        let lists = [[], [], [], []];
        data.chart.forEach(element => {
            lists[0].push(element.total_trama);
            lists[1].push(element.total_urdume);
            lists[2].push(element.total_manual);
            lists[3].push(element.total_outros);
        });

        const chartData = {
            labels: returnLabels(),
            datasets: [
                {
                    label: 'Trama',
                    data: lists[0],
                    backgroundColor: '#3498db',
                },
                {
                    label: 'Urdume',
                    data: lists[1],
                    backgroundColor: '#e74c3c',
                },
                {
                    label: 'Manual',
                    data: lists[2],
                    backgroundColor: '#e67e22'
                },
                {
                    label: 'Outros',
                    data: lists[3],
                    backgroundColor: '#2ecc71'
                }
            ]
        }

        return (
            <Chart
                id="chartQuebras2"
                data={chartData}
                height={printing ? "210mm" : "650px"}
                width={printing ? "297mm" : "100%"}
                options={options}
                plugins={[ChartDataLabels]}
                type="bar"
            />
        )
    };

    const QuebrasGrupo = () => {
        let lists = [[], [], [], []]
        const grupos = data.grupos;

        let labels = [];

        grupos.forEach(element => {
            if (element.tipo === 'trama') {
                lists[0].push(element.total);
            } else if (element.tipo === 'urdume') {
                lists[1].push(element.total)
            } else if (element.tipo === 'manual') {
                lists[2].push(element.total);
            } else if (element.tipo === 'outros') {
                lists[3].push(element.total);
            }
            let index = labels.indexOf(element.nome);
            if (index === -1) {
                labels.push(element.nome);
            }
        });

        const chartData = {
            labels: labels,
            datasets: [
                {
                    label: 'Trama',
                    data: lists[0],
                    backgroundColor: '#3498db'
                },
                {
                    label: 'Urdume',
                    data: lists[1],
                    backgroundColor: '#e74c3c'
                },
                {
                    label: 'Manual',
                    data: lists[2],
                    backgroundColor: '#e67e22',
                },
                {
                    label: 'Outros',
                    data: lists[3],
                    backgroundColor: '#2ecc71'
                }
            ],
        }

        return (
            <Chart
                id="chartQuebras3"
                data={chartData}
                height={printing ? "210mm" : "650px"}
                width={printing ? "297mm" : "100%"}
                options={options}
                plugins={[ChartDataLabels]}
                type="bar"
            />
        )
    };

    useEffect(() => {
        if(!data.datatable) return;
        let copy = [...data.datatable];
        let filtered = copy.filter((element) => {
            if(showTotal === true) {
                return element.trama >= trama && element.urdume >= urdume;
            } else {
                return element.trama >= trama && element.urdume >= urdume && element.turma !== 'Total';
            }
        });
        setFiltered(filtered);
    }, [data, trama, urdume, showTotal]);


    useEffect(() => {
        if (!data.datatable) return;

        const dadosDaTurma = data.datatable.filter(d => d.turma === turmaDia && d.turma !== 'Total');

        const datasExtraidas = [...new Set(dadosDaTurma.map(item => String(item.data).trim()))].sort();
        setUniqueDates(datasExtraidas);

        const tearesUnicos = [...new Set(dadosDaTurma.map(item => item.tear))].sort((a, b) => Number(a) - Number(b));
        setTearesOptions(tearesUnicos.map(t => ({ label: `Tear ${t}`, value: t })));

        const mapaTeares = {};
        dadosDaTurma.forEach(item => {
            const dataKey = String(item.data).trim();
            if (!mapaTeares[item.tear]) {
                mapaTeares[item.tear] = { 
                    tear: item.tear, 
                    eficiencia: item.eficiencia 
                };
            }
            mapaTeares[item.tear][`${dataKey}_urdume`] = item.urdume;
            mapaTeares[item.tear][`${dataKey}_trama`] = item.trama;
        });

        let dadosFinais = Object.values(mapaTeares);

        if (selectedTeares && selectedTeares.length > 0) {
            dadosFinais = dadosFinais.filter(d => selectedTeares.includes(d.tear));
        }

        setProcessedDiaData(dadosFinais);
    }, [data.datatable, turmaDia, selectedTeares]);

    const subColHeaders = uniqueDates.reduce((acc, date) => {
        acc.push(<Column key={`${date}_h_urd`} header="quebras de urdume" align="center" />);
        acc.push(<Column key={`${date}_h_tra`} header="quebras de trama" align="center" />);
        return acc;
    }, []);

    const bodyColumns = uniqueDates.reduce((acc, date) => {
        acc.push(
            <Column 
                key={`${date}_b_urd`} 
                field={`${date}_urdume`} 
                align="center" 
                body={(rowData) => rowData[`${date}_urdume`] !== undefined ? rowData[`${date}_urdume`] : '-'} 
            />
        );
        acc.push(
            <Column 
                key={`${date}_b_tra`} 
                field={`${date}_trama`} 
                align="center" 
                body={(rowData) => rowData[`${date}_trama`] !== undefined ? rowData[`${date}_trama`] : '-'} 
            />
        );
        return acc;
    }, []);

    const headerGroupDia = (
        <ColumnGroup type="header">
            <Row>
                <Column header="Tear" rowSpan={2} align="center" style={{ width: '80px' }} />
                <Column header="Eficiência" rowSpan={2} align="center" style={{ width: '100px' }} />
                {uniqueDates.map(date => (
                    <Column key={date} header={date} colSpan={2} align="center" />
                ))}
            </Row>
            <Row>
                {subColHeaders}
            </Row>
        </ColumnGroup>
    );

    return (
        <div>
            <Panel header="Tabela de Quebras" toggleable collapsed={true}>
                <div className="p-formgrid p-grid p-fluid">
                    <div className="p-field p-col">
                        <label htmlFor="trama">Trama: </label>
                        <InputNumber
                            className="p-m-1"
                            onChange={e => setTrama(e.value)}
                            placeholder="Acima de"
                            value={trama}
                        />
                    </div>
                    <div className="p-field p-col">
                        <label htmlFor="urdume">Urdume: </label>
                        <InputNumber
                            className="p-m-1"
                            onChange={e => setUrdume(e.value)}
                            placeholder="Acima de"
                            value={urdume}
                        />
                    </div>
                    <div className="p-field p-col">
                        <label htmlFor="button">Habilitar/Desabilitar Total</label>
                        <Button 
                            className="p-m-1"
                            label="Mostrar Total"
                            onClick={() => setShowTotal(!showTotal)}
                            title="Clique para HABILITAR ou DESABILITAR o total"
                        />
                    </div>
                </div>

                <DataTable filterDisplay="row" rowClassName={(rowData) => {
                    if (rowData.turma === 'Total') {
                        return 'datatable-quebras'
                    }
                }} value={filtered}>
                    <Column header="Tear" filter field="tear" style={{ width: "10%" }} />
                    <Column header="Data" filter field="data" style={{ width: "15%" }} />
                    <Column header="Turma" filter field="turma" style={{ width: "10%" }} showFilterMenu={false} />
                    <Column header="Grupo" filter field="grupo" style={{ width: "10%" }} showFilterMenu={false} />
                    <Column header="Eficiência" field="eficiencia" />
                    <Column header="Trama" field="trama" />
                    <Column header="Urdume" field="urdume" />
                    <Column header="Manuais" field="manual" />
                    <Column header="Total" field="total" />
                    <Column header="Quebras/hora" field="quebrashora" />
                </DataTable>
            </Panel>
            <Panel header="Quebras por dia" toggleable collapsed={true}>
                <div className="p-d-flex p-jc-between p-ai-center p-mb-4 p-flex-wrap">
                    <div className="p-mr-4 p-mb-3">
                        <label className="p-d-block p-mb-2 p-text-bold">Turma:</label>
                        <SelectButton 
                            value={turmaDia} 
                            options={turmaOptions} 
                            onChange={(e) => setTurmaDia(e.value)} 
                            unselectable={false} 
                        />
                    </div>
                    <div className="p-mb-3" style={{ minWidth: '250px' }}>
                        <label className="p-d-block p-mb-2 p-text-bold">Teares:</label>
                        <MultiSelect 
                            value={selectedTeares} 
                            options={tearesOptions} 
                            onChange={(e) => setSelectedTeares(e.value)} 
                            placeholder="Selecione os Teares" 
                            display="chip" 
                            filter 
                            className="p-w-100" 
                        />
                    </div>
                </div>
                <div className="p-mb-3">
                    <Button className="p-button p-m-1" icon="pi pi-print" onClick={handlePrintDia} />
                </div>
                <div ref={tableDiaRef} style={{ padding: printingDia ? '20px' : '0' }}>
                    {printingDia && (
                        <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                            <h2>Relatório de Quebras por Dia - Turma {turmaDia}</h2>
                        </div>
                    )}
                    <DataTable 
                        value={processedDiaData} 
                        headerColumnGroup={headerGroupDia} 
                        emptyMessage="Nenhum dado encontrado para a turma/teares selecionados"
                        className="p-datatable-sm p-datatable-gridlines" 
                        stripedRows
                    >
                        <Column field="tear" align="center" />
                        <Column field="eficiencia" align="center" body={(row) => `${row.eficiencia}%`} />
                        {bodyColumns}
                    </DataTable>
                </div>
            </Panel>
            {/* Quebras dia por artigo */}
            <QuebrasDiaArtigo />
            {/* Quebras dia resumo por artigo */}
            <QuebrasResumoArtigo />
            {/* Ocorrencias de quebra por artigo */}
            <QuebrasOcorrenciasArtigo />
            {/* Gráfico de controle de quebras */}
            <QuebrasControle />
            <Panel header="GRÁFICO DE QUEBRAS TOTAL POR TURMA" toggleable collapsed={true}>
                <Button className="p-m-2" icon="pi pi-print" onClick={() => handlePrint('chartQuebras1')} />
                <QuebrasTurma />
            </Panel>
            <Panel header="GRÁFICO DE QUEBRAS DE TRAMA E URDUME POR TURMA" toggleable collapsed={true}>
                <Button className="p-m-2" icon="pi pi-print" onClick={() => handlePrint('chartQuebras2')} />
                <QuebrasTotais />
            </Panel>
            <Panel header="GRÁFICO DE QUEBRAS DE TRAMA E URDUME POR GRUPO DE MÁQUINAS" toggleable collapsed={true}>
                <Button className="p-m-2" icon="pi pi-print" onClick={() => handlePrint('chartQuebras3')} />
                <QuebrasGrupo />
            </Panel>
        </div>
    )
});